export enum TDevice {
    unknown,
    desktop,
    mobile,
    tablet,
}
